import TableImporter from './TableImporter';
import DiagramTranslate from 'diagram-js/lib/i18n/translate';

export default {
  __depends__: [ DiagramTranslate ],
  tableImporter: [ 'type', TableImporter ]
};